import React from "react";
import { Carousel, Col, Row } from "react-bootstrap";
import purebanner1 from "../../assets/images/banner/pure-banner1.jpg";
import purebanner2 from "../../assets/images/banner/pure-banner2.jpg";
import purebanner3 from "../../assets/images/banner/pure-banner3.jpg";

function HomeBannerSlider() {
  return (
    <section className="video__banner">
      <Carousel
        indicators={false}
        navigators={false}
        pause={false}
        arrows={false}
        autoplay={true}
      >
        {/* <Carousel.Item interval={4000}>
        <Row className="justify-content-center">
          <Col xs={12} md={12}>
            <picture>
              <source srcSet={banner1} type="image/webp" />
              <img src={banner1} alt="" className="w-100" />
            </picture>
            <div className="bannerText1">
              <h2 className="wow zoomIn animated" data-wow-delay="1s">
                Don't just <br /> Hydrate, Pure IONIA! <br />
                Experience the difference
                <br /> with <span>Pure Ionia</span>
              </h2>
            </div>
          </Col>
        </Row>
      </Carousel.Item> */}
        <Carousel.Item interval={15000000}>
          <Row className="justify-content-center">
            <Col xs={12} md={12}>
              <picture>
                <source srcSet={purebanner1} type="image/webp" />
                <img src={purebanner1} alt="" className="w-100" />
              </picture>
              <p className="text-white fst-italic fs-1 fw-bold firstFixedText">
                Ionized Water, Infinite Benefits
              </p>
              <div className="bannerText2 text-center ">
                <h2
                  className="wow fadeInLeft animated text-white mb-2"
                  data-wow-delay="1s"
                >
                  "Acidic to Alkaline - Customize Your Water,
                  <span
                    className="wow fadeInLeft animated"
                    data-wow-delay="1.8s"
                  >
                    {" "}
                    Elevate Your life!"
                  </span>{" "}
                </h2>
              </div>
            </Col>
          </Row>
        </Carousel.Item>
        <Carousel.Item interval={6000}>
          <Row className="justify-content-center">
            <Col xs={12} md={12}>
              <pitcure>
                <source srcSet={purebanner2} type="image/webp" />
                <img src={purebanner2} alt="" className="w-100" />
              </pitcure>
              <div className="bannerText3">
                <h2
                  className="wow zoomIn animated text-blue"
                  data-wow-delay="1s"
                >
                  "Begin your day with a fresh glass of{" "}
                  <strong>Pure Ionia Alkaline Water"</strong>
                  <span
                    className="wow zoomIn animated text-white"
                    data-wow-delay="1.8s"
                  >
                    – Because a healthy start leads to a better day!
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
        </Carousel.Item>
        <Carousel.Item interval={6000}>
          <Row className="justify-content-center">
            <Col xs={12} md={12}>
              <picture>
                <source srcSet={purebanner3} type="image/webp" />
                <img src={purebanner3} alt="" className="w-100" />
              </picture>
              <div className="bannerText4">
                <h2
                  className="wow fadeInLeft animated fs-1 mt-4"
                  data-wow-delay="1s"
                >
                  "Experience the power of <br />
                  good health with Pure Ionia’s <br />
                  Alkaline Water Ionizers"{" "}
                  <span
                    className="wow fadeInLeft animated text-blue fs-1  "
                    data-wow-delay="1.8s"
                  >
                    - Because better water <br />
                    means a better you!
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
        </Carousel.Item>
      </Carousel>
    </section>
  );
}

export default HomeBannerSlider;
